var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRxSidemenuAssessment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2840_9211)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.1048 17.9147L11.9998 19.9997L4.49981 12.5717C4.00512 12.0903 3.61546 11.5117 3.35536 10.8723C3.09527 10.2329 2.97037 9.54664 2.98855 8.85662C3.00673 8.1666 3.16758 7.48782 3.46097 6.86303C3.75436 6.23823 4.17395 5.68094 4.6933 5.22627C5.21265 4.77159 5.82052 4.42938 6.47862 4.22117C7.13673 4.01296 7.83082 3.94327 8.51718 4.01649C9.20354 4.08971 9.86731 4.30425 10.4667 4.64659C11.0661 4.98894 11.5881 5.45169 11.9998 6.00569C12.743 5.01664 13.8265 4.33825 15.0408 4.10164C16.2551 3.86503 17.514 4.08701 18.5742 4.72467C19.6344 5.36234 20.4205 6.3704 20.7806 7.55398C21.1407 8.73757 21.0492 10.0126 20.5238 11.1327",
    stroke: "#767679",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 22V22.01",
    stroke: "#767679",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 18.9998C19.4483 18.9983 19.8832 18.8466 20.235 18.5687C20.5868 18.2909 20.8352 17.903 20.9406 17.4673C21.0459 17.0315 21.0019 16.5731 20.8158 16.1652C20.6297 15.7574 20.3122 15.4238 19.914 15.2178C19.5162 15.014 19.0611 14.9508 18.6228 15.0385C18.1845 15.1262 17.7888 15.3596 17.5 15.7008",
    stroke: "#767679",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2840_9211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxSidemenuAssessment);
export default __webpack_public_path__ + "static/media/rx-sidemenu-assessment.e8e012f5a9d7a77bd1aec70e828692e3.svg";
export { ForwardRef as ReactComponent };